/* /assets/os-availability-default.js
 * Step 4b REBUILD (James: eliminate the sold-out flash-then-reflow the old
 * JS+AJAX default caused). The in-stock default is no longer applied here at
 * all -- it's now server-rendered CSS, present from first paint with no JS
 * required (sections/collection.liquid puts `os-hide-soldout` on the grid
 * unconditionally; snippets/product-grid-item.liquid puts `os-card--soldout`
 * on each sold-out card; assets/os-filters.css hides the latter inside the
 * former). Nothing in this file runs before that first paint, so there is
 * nothing left to flash.
 *
 * This file's only remaining job: let the "Show out of stock" toggle
 * (snippets/filters.liquid, data-os-hide-soldout-toggle) remove/restore the
 * `os-hide-soldout` class on the grid. That's a plain class flip, not a
 * facet -- the checkbox has no name/value and submits nothing, so there's no
 * FiltersForm/AJAX pipeline involved and no grid re-fetch for this toggle.
 *
 * Delegated on `document` (not bound to the toggle checkbox directly)
 * because the toggle lives inside [data-collection-sidebar], whose innerHTML
 * FiltersForm replaces wholesale on every OTHER facet's AJAX swap -- a
 * direct listener on the original checkbox would be destroyed and never
 * rebound. Delegation keeps working across every swap with no rewiring.
 * (Known, accepted consequence: the "show out of stock" choice does not
 * persist across an unrelated facet swap, since the freshly-rendered
 * checkbox comes back unchecked and the grid keeps whatever class state it
 * already had. Marked optional in the brief; not implemented here.)
 */
(function () {
  'use strict';

  function applyToGrids(showSoldOut) {
    document.querySelectorAll('.js-grid').forEach(function (grid) {
      grid.classList.toggle('os-hide-soldout', !showSoldOut);
    });
  }

  document.addEventListener('change', function (evt) {
    var toggle = evt.target.closest('[data-os-hide-soldout-toggle]');
    if (!toggle) return;

    applyToGrids(toggle.checked);
  });
})();
